


















































































import Vue from 'vue'
import { DashboardTemplate } from '../../base/store/state.interface'
import { PermutatorService } from '../widgets/base/permutator'
import BaseDialog from './BaseDialog.vue'
import WidgetContainerFactory from '../widgets/container/WidgetContainerFactory'

export default Vue.extend({
  components: {
    BaseDialog
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    alarmTemplateId: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      isInitialised: false
    }
  },
  computed: {
    selectedTemplate() {
      return this.$store.state.dashboard?.selectedTemplate || {}
    },
    availableTemplates() {
      const availableTemlates = this.$store.state.dashboard?.templates || []
      const templates = JSON.parse(JSON.stringify(availableTemlates)) as Array<DashboardTemplate>

      templates.sort((a,b) => (a.title < b.title) ? -1 : (a.title > b.title) ? 1 : 0)
      templates.unshift({
        title: '(Leeres Dashboard)',
        dashboard: JSON.stringify(WidgetContainerFactory.create())
      })
      return templates
    }
  },
  methods: {
    selectDashboard(dashboard) {
      this.$emit('selectDashboard', dashboard)
    },
    async onShowDialog() {
      if (this.isInitialised) {
        return
      }

      await this.$store.dispatch('loadDashboardLayouts')

      this.isInitialised = true
    }
  }
})
